import { createPlugin } from "@backstage/core-plugin-api";
import { createCardExtension } from "@backstage/plugin-home-react";

/**
 * Legacy plugin registration — required for {@link IncidentHomeCard}, which is
 * built with the `createCardExtension` home-react API so it can be placed in the
 * home page's `CustomHomepageGrid`. Mirrors the policy-center-react pattern; the
 * entity cards use the new frontend system in the separate `incidentio` package.
 */
export const incidentioPlugin = createPlugin({
    id: "incidentio",
});

/**
 * Home-page widget: on-call for the user's team, with the ability to search for
 * and switch to any other team. See
 * {@link ./components/IncidentHomeCard/IncidentHomeCard#Content}.
 */
export const IncidentHomeCard = incidentioPlugin.provide(
    createCardExtension({
        name: "IncidentHomeCard",
        title: "Incident.io On-Call",
        description:
            "Shows who is on-call for your team, with the ability to search and switch teams.",
        // Sizing intent expressed as a CardLayout hint. `CardLayout` is shared
        // with the NFS `HomePageWidgetBlueprint`, so this migrates for free when
        // the home page moves off the legacy absolute x/y grid — unlike the
        // coordinates in app-module-home's `defaultGridConfig`.
        layout: {
            width: { minColumns: 3, defaultColumns: 3, maxColumns: 12 },
            height: { minRows: 4, defaultRows: 4 },
        },
        components: () =>
            import("./components/IncidentHomeCard/IncidentHomeCard").then(
                m => ({
                    Content: m.Content,
                })
            ),
    })
);
